import React from 'react';

export default function GlobalStyles() {
  return (

    <style>{`
:root{
  --bg: #0f172a;            /* slate-900 for dark mode base */
  --surface: #111827;       /* gray-900 */
  --muted: #334155;         /* slate-600 */
  --text: #e5e7eb;          /* gray-200 */
  --brand: #16a34a;         /* green-600 */
  --brand-2: #0ea5e9;       /* sky-500 */
  --accent: #f59e0b;        /* amber-500 */
  --card: #0b1220;          /* deep slate */
  --ring: rgba(20,184,166,.4);
  --ok: #10b981;            /* emerald */
  --danger: #ef4444;        /* red-500 */
  --shadow: 0 10px 25px rgba(0,0,0,.25), 0 2px 8px rgba(0,0,0,.2);
}
@media (prefers-color-scheme: light){
  :root{
    --bg: #f8fafc;          /* slate-50 */
    --surface: #ffffff;      /* white */
    --muted: #64748b;        /* slate-500 */
    --text: #0f172a;         /* slate-900 */
    --brand: #059669;        /* green-600 darker */
    --brand-2: #0284c7;      /* sky-600 */
    --accent: #b45309;       /* amber-700 */
    --card: #ffffff;
    --shadow: 0 12px 32px rgba(2,8,23,.08), 0 2px 8px rgba(2,8,23,.06);
  }
}
*{ box-sizing:border-box }
html, body{ margin:0; padding:0; background:var(--bg); color:var(--text); font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"; }
a{ color:inherit; text-decoration:none }
.container{ width:min(1200px, 92%); margin:0 auto }
.ann{ background: linear-gradient(90deg, var(--brand) , var(--brand-2)); color:white; padding:.55rem 0; font-weight:600; letter-spacing:.2px; }
.ann .container{ display:flex; align-items:center; justify-content:center; gap:.6rem; font-size:.95rem }
.badge{ display:inline-block; padding:.2rem .5rem; border-radius:999px; background:rgba(255,255,255,.15); border:1px solid rgba(255,255,255,.4); font-size:.8rem }
header{ position:sticky; top:0; z-index:50; backdrop-filter: saturate(180%) blur(8px); background: color-mix(in oklab, var(--bg) 85%, transparent); border-bottom:1px solid color-mix(in oklab, var(--muted) 25%, transparent); }
.nav{ display:flex; align-items:center; gap:1rem; padding: .9rem 0 }
.logo{ display:flex; align-items:center; gap:.7rem; font-weight:800; font-size:1.15rem; letter-spacing:.3px }
.logo svg{ width:34px; height:34px }
.search{ flex:1; display:flex; align-items:center; gap:.5rem; }
.search input{ width:100%; padding:.75rem 1rem; border-radius:12px; outline: none; border:1px solid color-mix(in oklab, var(--muted) 30%, transparent); background:var(--surface); color:var(--text); box-shadow: inset 0 1px 0 rgba(255,255,255,.03); }
.search input:focus{ border-color: var(--brand-2); box-shadow: 0 0 0 4px color-mix(in oklab, var(--brand-2) 25%, transparent); }
.nav-links{ display:flex; align-items:center; gap:1rem; }
.pill{ padding:.6rem .9rem; border-radius:999px; border:1px solid color-mix(in oklab, var(--muted) 25%, transparent); background:var(--surface) }
.cta{ background:linear-gradient(180deg, var(--brand-2), var(--brand)); color:white; border:none }
.menu-btn{ display:none; }
@media (max-width: 880px){
  .nav-links{ display:none }
  .menu-btn{ display:inline-flex; margin-left:.25rem }
}
.hero{ display:grid; grid-template-columns: 1.2fr .9fr; gap:2rem; align-items:center;  }
@media (max-width: 880px){ .hero{ grid-template-columns: 1fr } }
.kicker{ font-weight:700; color:var(--brand-2); letter-spacing:.4px; font-size:.9rem; text-transform:uppercase }
h1{ font-size: clamp(2rem, 3.6vw + .8rem, 3.25rem); margin:.4rem 0 1rem; line-height:1.06 }
.lead{ color:var(--muted); font-size: clamp(1rem, .8vw + .8rem, 1.15rem); max-width: 60ch }
.hero-card{ background: radial-gradient(1200px 500px at 60% -10%, color-mix(in oklab, var(--brand) 16%, transparent), transparent 60%), var(--card); padding:1.2rem; border-radius:20px; box-shadow: var(--shadow); border:1px solid color-mix(in oklab, var(--muted) 22%, transparent); }
.hero-grid{ display:grid; grid-template-columns: repeat(2, 1fr); gap:1rem }
.category{ background: var(--surface); border-radius:14px; padding:1rem; border:1px dashed color-mix(in oklab, white 50%, transparent); display:flex; gap:.9rem; align-items:center; min-height:86px }
.category svg{ width:28px; height:28px }
.actions{ display:flex; gap:.8rem; margin-top:1.2rem; flex-wrap:wrap }
.btn{ display:inline-flex; align-items:center; gap:.5rem; font-weight:700; padding:.8rem 1rem; border-radius:12px; border:1px solid white; background:var(--surface) }
.btn .dot{ width:8px; height:8px; border-radius:50%; background:var(--brand-2) }
.btn.primary{ background:linear-gradient(180deg, var(--brand-2), var(--brand)); border:none; color:white }
.trust{ display:flex; gap:1rem; flex-wrap:wrap; margin-top:1rem; color:var(--muted); font-size:.95rem }
.trust .chip{ display:flex; align-items:center; gap:.4rem; padding:.4rem .6rem; border-radius:999px; border:1px solid color-mix(in oklab, #fff 50%, transparent); }
.section{ padding: 2.2rem 0 }
.section h2{ font-size: clamp(1.35rem, 1.4vw + .9rem, 2rem); margin:0 0 .8rem }
.grid{ display:grid; grid-template-columns: repeat(4, 1fr); gap:1rem }
@media (max-width: 1000px){ .grid{ grid-template-columns: repeat(3, 1fr) } }
@media (max-width: 720px){ .grid{ grid-template-columns: repeat(2, 1fr) } }
.card{ background:var(--surface); border:1px solid color-mix(in oklab, var(--muted) 22%, transparent); border-radius:16px; overflow:hidden; box-shadow: var(--shadow) }
.thumb{ aspect-ratio: 4/3; background:linear-gradient(135deg, color-mix(in oklab, var(--brand-2) 12%, transparent), transparent 60%), color-mix(in oklab, var(--muted) 18%, transparent); display:flex; align-items:center; justify-content:center }
.thumb svg{ width:60px; height:60px; opacity:.8 }
.card .body{ padding: .9rem }
.price{ font-weight:800 }
.pill.sm{ padding:.3rem .6rem; font-size:.8rem }
.cards-row{ display:grid; grid-template-columns: 2fr 1fr; gap:1rem }
@media (max-width: 1000px){ .cards-row{ grid-template-columns: 1fr } }
.callout{ background: linear-gradient(180deg, color-mix(in oklab, var(--brand-2) 14%, var(--surface)), var(--surface)); border:1px solid color-mix(in oklab, var(--muted) 22%, transparent); border-radius:16px; padding:1.2rem }
.callout strong{ color: var(--brand) }
.list{ display:grid; gap:.7rem; margin:.8rem 0 0 }
.list li{ display:flex; align-items:flex-start; gap:.6rem; }
.list svg{ width:18px; height:18px; margin-top:.15rem }
footer{ margin-top:2.4rem; padding:2.4rem 0 3.2rem; background: color-mix(in oklab, var(--surface) 70%, var(--bg)); border-top: 1px solid color-mix(in oklab, var(--muted) 25%, transparent) }
.foot-grid{ display:grid; grid-template-columns: 1.5fr 1fr 1fr; gap:1.4rem }
@media (max-width: 880px){ .foot-grid{ grid-template-columns: 1fr } }
.subtle{ color: var(--muted) }
.sr-only{ position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0; }
.mobile-menu{ display:none; }
.show{ display:block !important }
      `}</style>

  )
}
